import {env} from './env';
import {paths} from './paths';

export const config = {env, paths};
